/**
 * Aggregates every patient-record resource slice into a single object. Used by
 * `src/api/client.ts` to extend the legacy `apiClient` surface; new code should
 * prefer the per-resource slice import for narrower types.
 */
export { patientApi } from './patient';
export type {
  PersonDto,
  PersonSummaryDto,
  LiveSexCode,
  CreatePersonSexCode,
  LiveDemographicsBody,
  LiveInterpreterRequired,
  CreatePersonInput,
  CareTeamMemberDto,
  PersonMetadataWithCareTeamDto,
  EthnicityDto,
  EthnicityTermDto,
  PhysicalChartDto,
} from './patient';

export { identifiersApi } from './identifiers';
export type { IdentifierInUseResponseDto } from './identifiers';

export { featuresApi } from './features';
export type {
  LiveFeatureType,
  LiveFeatureObserved,
  LiveFeatureQualifierType,
  LiveFeatureQualifier,
  LiveFeatureQualifierGroup,
  LiveFeatureDate,
  LiveFeatureSource,
  LiveFeatureCreateInput,
} from './features';

export { diagnosesApi } from './diagnoses';

export { variantsApi } from './variants';
export type {
  LiveVariantPartialDate,
  LiveVariantSource,
  GeneticInfoDto,
} from './variants';

export { medicalHistoryApi } from './medicalHistory';

export { measurementsApi } from './measurements';

export { allergyProfileApi } from './allergyProfile';

export { notesApi } from './notes';
export type { NoteInputDto } from './notes';

export { documentsApi } from './documents';

export { testOrdersApi } from './testOrders';

export { questionnairesApi } from './questionnaires';

export { consentsApi } from './consents';

export { carePathwaysApi } from './carePathways';
export type {
  CarePathwayDto,
  CarePathwayStatusCode,
  CarePathwayStatusRequest,
  CarePathwayStepDto,
  CarePathwayStepRequest,
  CarePathwayStepStatusCode,
  CarePathwayTemplateDto,
  CarePathwayTemplateInput,
  CarePathwayTemplateStateCode,
  CarePathwayTemplateStateRequest,
  CarePathwayTemplateStepDto,
} from './carePathways';

export { exportsApi } from './exports';

export { careTeamApi, mapCareTeamMemberRow } from './careTeam';
export type {
  AddCareTeamMemberBody,
  CareTeamMemberRowDto,
  TenantProgramDto,
  TenantUserDto,
} from './careTeam';

export { tasksApi } from './tasks';
export type {
  ListTasksParams,
  TaskDto,
  TaskPageDto,
  TaskPriorityCode,
  TaskStatusCode,
  TaskSummaryDto,
  TaskTypeCode,
  UpdateTaskInput,
} from './tasks';

import { patientApi } from './patient';
import { identifiersApi } from './identifiers';
import { featuresApi } from './features';
import { diagnosesApi } from './diagnoses';
import { variantsApi } from './variants';
import { medicalHistoryApi } from './medicalHistory';
import { measurementsApi } from './measurements';
import { allergyProfileApi } from './allergyProfile';
import { notesApi } from './notes';
import { documentsApi } from './documents';
import { testOrdersApi } from './testOrders';
import { questionnairesApi } from './questionnaires';
import { consentsApi } from './consents';
import { carePathwaysApi } from './carePathways';
import { exportsApi } from './exports';
import { careTeamApi } from './careTeam';
import { tasksApi } from './tasks';

export const patientRecordApi = {
  ...patientApi,
  ...identifiersApi,
  ...featuresApi,
  ...diagnosesApi,
  ...variantsApi,
  ...medicalHistoryApi,
  ...measurementsApi,
  ...allergyProfileApi,
  ...notesApi,
  ...documentsApi,
  ...testOrdersApi,
  ...questionnairesApi,
  ...consentsApi,
  ...carePathwaysApi,
  ...exportsApi,
  ...careTeamApi,
  ...tasksApi,
};
